import { Fragment } from 'react';
import PreviewBackground from 'ContentComponents/cmv2/media/PreviewBackground';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import { jsx as _jsx } from "react/jsx-runtime";
const VideoPreviewContainer = props => /*#__PURE__*/_jsx(Fragment, {
  children: /*#__PURE__*/_jsx(PreviewBackground, {
    children: /*#__PURE__*/_jsx(UIFlex, {
      justify: "center",
      children: /*#__PURE__*/_jsx(UIBox, {
        basis: 400,
        children: props.children
      })
    })
  })
});
export default VideoPreviewContainer;